import { render, staticRenderFns } from "./HorseLamp.vue?vue&type=template&id=5a9e1d92&scoped=true"
import script from "./HorseLamp.vue?vue&type=script&lang=js"
export * from "./HorseLamp.vue?vue&type=script&lang=js"
import style0 from "./HorseLamp.vue?vue&type=style&index=0&id=5a9e1d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e1d92",
  null
  
)

export default component.exports